import RankContinuityPanel from './RankContinuityPanel';
import SponsoredCountDropPanel from './SponsoredCountDropPanel';
import JsonPayloadFallback from './JsonPayloadFallback';

export const ISSUE_TYPE_RENDERERS = {
  'rank-continuity': RankContinuityPanel,
  'sponsored-count-drop': SponsoredCountDropPanel,
};

export function getIssueTypeRenderer(issueType) {
  return ISSUE_TYPE_RENDERERS[issueType] || JsonPayloadFallback;
}

export function issueTypeLabel(issueType) {
  if (issueType === 'non-null-issues') return 'Non-Null';
  if (issueType === 'null-issues' || !issueType) return 'Null';
  return String(issueType).replace(/-/g, ' ');
}
